module.exports = __webpack_public_path__ + "img/attend-reservation.8977e259.svg";